import React, { useState, useEffect } from 'react';
import Button from 'devextreme-react/button';
import DataGrid, {
    Column, Editing, Paging, Lookup, Scrolling
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { webDashboardService } from '../../services/WebDashboardService'
import notify from 'devextreme/ui/notify';
import { storeLevel, userLevel } from '../../utils/enums';
import { useNavigate } from "react-router-dom";

export default function DashboardList() {
    const [dashboardData, setdashboardData] = useState();
    const [storeLevelData, setStoreLevelData] = useState();
    const [userLevelData, setUserLevelData] = useState();
    const [storeData, setStoreData] = useState();
    const navigate = useNavigate();
    const dashboardsDS = () => {
        return {            
            store: new CustomStore({
                key: 'id',
                load: async () => {
                    let result = await getWebDashboards();
                    setStoreData(result.webDashboardStore);
                    return {                        
                        data: result.webDashboardStorage,
                    };
                },
                update: async (key, values) => {
                    values.id = key;
                    if (key > 0) {
                        await updateWebDashboards(values);
                        toast('Dashboard updated', 'success')
                    }
                },
                remove: async (key) => {
                    if (key > 0) {
                        await deleteWebDashboards(key);
                        toast('Dashboard deleted', 'success')
                    }
                }
            })
        }
    }

    const getWebDashboards = async () => {
        return await webDashboardService.Get();
    }
    const updateWebDashboards = async (values) => {
        return await webDashboardService.Update(values);
    }

    const deleteWebDashboards = async (id) => {
        return await webDashboardService.Delete(id);
    }

    useEffect(() => {
        setdashboardData(dashboardsDS());
        setStoreLevelData(storeLevel);
        setUserLevelData(userLevel);
    }, []);

    const toast = (message, infoType) => {
        notify({
            message: message,
            position: {
                my: 'center top',
                at: 'center top'
            }
        }, infoType, 3000);
    }

    const onBackClick = (e) => {
        navigate("/dashboard");
    }
    return (
        <div style={{ 'padding': "10px" }}>
            <div>
                <Button
                    icon="back"
                    width={180}
                    text="DASHBOARD"
                    type="normal"
                    stylingMode="outlined"
                    className='dxbuttonBack'
                    onClick={onBackClick}
                />
            </div>
            <React.Fragment>
                <DataGrid
                    id="gridContainer"
                    dataSource={dashboardData}
                    keyExpr="id"
                    allowColumnReordering={true}
                    showBorders={true}
                    height={800}
                >
                    <Scrolling mode="virtual" />
                    <Paging enabled={true} />
                    <Editing
                        mode="row"
                        allowUpdating={true}
                        allowDeleting={true}
                        useIcons={true}
                    />
                    <Column dataField="name" caption="Navn" />
                    <Column dataField="ownerStoreID" caption="butikk">
                        <Lookup dataSource={storeData} displayExpr="storeName" valueExpr="storeId" />
                    </Column>
                    <Column dataField="ownerStoreLevel" caption="Eier butikknivå">
                        <Lookup dataSource={storeLevelData} displayExpr="Name" valueExpr="ID" />
                    </Column>
                    <Column dataField="includedStoresLevel" caption="Inkludert butikknivå">
                        <Lookup dataSource={storeLevelData} displayExpr="Name" valueExpr="ID" />
                    </Column>
                    <Column dataField="viewStoreLevel" caption="Se butikknivå">
                        <Lookup dataSource={storeLevelData} displayExpr="Name" valueExpr="ID" />
                    </Column>
                    <Column dataField="userViewLevel" caption="Brukerbutikknivå">
                        <Lookup dataSource={userLevelData} displayExpr="Name" valueExpr="ID" />
                    </Column>
                </DataGrid>
            </React.Fragment>
        </div>
    );
}